/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ClassificationTierTarget,
    ClassificationTierTargetFromJSON,
    ClassificationTierTargetToJSON,
} from '../models/ClassificationTierTarget';

export interface DeleteTargets1Request {
    id: string;
}

export interface GetAllTierRangesRequest {
    id: string;
}

export interface UpdateTierRangesRequest {
    id: string;
    classificationTierTarget: Array<ClassificationTierTarget>;
}

/**
 * 
 */
export class SegmentClassificationTierTargetApi extends runtime.BaseAPI {

    /**
     * Creates request options for deleteTargets1 without sending the request
     */
    async deleteTargets1RequestOpts(requestParameters: DeleteTargets1Request): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteTargets1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/segment/{id}/classification-tier/target`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteTargets1Raw(requestParameters: DeleteTargets1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteTargets1RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteTargets1(requestParameters: DeleteTargets1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTargets1Raw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getAllTierRanges without sending the request
     */
    async getAllTierRangesRequestOpts(requestParameters: GetAllTierRangesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAllTierRanges().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/segment/{id}/classification-tier/target`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAllTierRangesRaw(requestParameters: GetAllTierRangesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ClassificationTierTarget>>> {
        const requestOptions = await this.getAllTierRangesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClassificationTierTargetFromJSON));
    }

    /**
     */
    async getAllTierRanges(requestParameters: GetAllTierRangesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ClassificationTierTarget>> {
        const response = await this.getAllTierRangesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateTierRanges without sending the request
     */
    async updateTierRangesRequestOpts(requestParameters: UpdateTierRangesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateTierRanges().'
            );
        }

        if (requestParameters['classificationTierTarget'] == null) {
            throw new runtime.RequiredError(
                'classificationTierTarget',
                'Required parameter "classificationTierTarget" was null or undefined when calling updateTierRanges().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/segment/{id}/classification-tier/target`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['classificationTierTarget']!.map(ClassificationTierTargetToJSON),
        };
    }

    /**
     */
    async updateTierRangesRaw(requestParameters: UpdateTierRangesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ClassificationTierTarget>>> {
        const requestOptions = await this.updateTierRangesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClassificationTierTargetFromJSON));
    }

    /**
     */
    async updateTierRanges(requestParameters: UpdateTierRangesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ClassificationTierTarget>> {
        const response = await this.updateTierRangesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
